<template>
    <section style="top: 0px; right: 0px;">
        <div class="flexContainer abs full" id="noResults" v-if="getScratchPad.length === 0">
            <h3 class="uppercase txtCenter">{{ $t("scratchPad.noScratch") }}</h3>
        </div>
        <div id="scratchContent" class="scrollY flexContainer fw-w"></div>
    </section>
</template>

<script>
const d3 = require("d3"); // eslint-disable-line no-unused-vars

import Vuex from "vuex";
import { planoMixin } from "../mixins/plano.js";
import { bus } from "../../../main";

export default {
    mixins: [planoMixin],
    data: () => ({
        loading: false
    }),
    watch: {
        loading() {}
    },
    computed: {
        ...Vuex.mapGetters({
            getScratchPad: "plano/status/getScratchPad"
        })
    },
    mounted() {
        this.loadScratchpad();
        bus.$on("reload_scratchpad", () => {
            this.loadScratchpad();
        });
    },
    beforeDestroy() {
        bus.$off("reload_scratchpad");
    },
    methods: {
        loadScratchpad() {
            let scratchContent = document.querySelector("#scratchContent");
            this.getScratchPad.forEach(scratchpad => {
                let copModule = scratchpad.svg;
                scratchContent.appendChild(copModule);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
#noResults {
    height: 100%;
    h3 {
        margin: auto;
    }
}

#spinnerLoader {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10;
    .loader {
        margin: auto;
    }
}

#scratchContent {
    background: #fff;
    height: calc(100vh - 176px);
    padding: 30px 15px 15px;
}
</style>



// WEBPACK FOOTER //
// ScratchPad.vue?4fdcf0b7